import { markRaw, ref } from 'vue'
import { defineStore } from 'pinia'

export const useModalStore = defineStore('modal', () => {
  const modals = ref([])

  const openModal = (component, props = {}) => {
    const id = Date.now()
    modals.value.push({ id, component: markRaw(component), props })
    return id
  }

  const closeModal = (id) => {
    const index = modals.value.findIndex(m => m.id === id)
    if (index !== -1) {
      modals.value.splice(index, 1)
    }
  }

  const closeAllModals = () => {
    modals.value = []
  }

  const $reset = () => {
    modals.value = []
  }

  return {
    modals,
    openModal,
    closeModal,
    closeAllModals,
    $reset,
  }
})
